import * as moment from 'moment';
import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class DatetimeQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.DATETIME;
  displayFormat: string;
  pickerFormat: string;
  placeholder: string;
  defaultDate: Date;
  allowFutureDate: boolean;
  max?: string;
  min?: string;
  cancelText: string;
  doneText: string;
  mobiDateFormat: string;
  type: 'datetime' | 'time' | 'date';
  format: string;

  constructor(options: any = {}) {
    super(options);
    this.type = options['type'] || 'datetime';
    this.format = options['format'] || this.getDefaultFormat();
    this.displayFormat =
      options['displayFormat'] || this.getDefaultDisplayFormat();
    this.pickerFormat =
      options['pickerFormat'] || this.getDefaultPickerFormat();
    this.mobiDateFormat =
      options['mobiDateFormat'] || this.getDefaultMobiDateFormat();
    this.placeholder = options['placeholder'] || void 0;
    this.defaultDate = options['defaultDate'] || void 0;
    this.allowFutureDate = options['allowFutureDate'];
    this.max = this.getDefaultMaxDate(
      options['max'],
      options['allowFutureDate'],
      this.mobiDateFormat
    );
    this.min = options['min'] || void 0;
    this.cancelText = options['cancelText'] || 'CANCEL';
    this.doneText = options['doneText'] || 'OK';
  }

  private getDefaultFormat(): string {
    switch (this.type) {
      case 'time':
        return 'HH:mm'; // 24-hour format
      case 'date':
        return 'dd/mm/yyyy';
      case 'datetime':
      default:
        return 'dd/mm/yyyy HH:mm'; // 24-hour format
    }
  }

  private getDefaultDisplayFormat(): string {
    return this.format || this.getDefaultFormat();
  }

  private getDefaultPickerFormat(): string {
    switch (this.type) {
      case 'time':
        return 'HH:mm';
      case 'date':
        return 'YYYY-MM-DD';
      case 'datetime':
      default:
        return 'YYYY-MM-DDTHH:mm';
    }
  }

  private getDefaultMobiDateFormat(): string {
    switch (this.type) {
      case 'time':
        return 'HH:mm';
      case 'date':
        return 'YYYY-MM-DD';
      case 'datetime':
      default:
        return 'YYYY-MM-DDTHH:mm:ss';
    }
  }

  private getDefaultMaxDate(
    maxValue: string,
    allowFuturDate: boolean,
    dateFormat: string,
    yearsToAdd = 50
  ): string {
    const now = moment().utc(true).format(dateFormat);
    let maxDate: string;

    if (allowFuturDate !== undefined && !allowFuturDate) {
      if (maxValue) {
        maxDate = new Date(now) < new Date(maxValue) ? now : maxValue;
      } else {
        maxDate = now.toString();
      }
    } else if (maxValue) {
      maxDate = maxValue;
    } else {
      maxDate = (new Date().getFullYear() + yearsToAdd).toString();
    }
    return maxDate;
  }
}
